// @core/api/endpoints/team/extend_role_delegation.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ExtendRoleDelegationRequest,
} from '../../../types/team';

const BASE_PATH = '/team';

/**
 * Extend delegation period
 * Performs extend operation on role delegation.
 */
export async function ExtendRoleDelegation(
  team_id: string,
  delegation_id: string,
  data: ExtendRoleDelegationRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:team_id/delegations/:delegation_id/extend`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  requestPath = requestPath.replace(':delegation_id', encodeURIComponent(delegation_id));
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
